import { createContext } from "react"

export const authContext = createContext({
  authenticated: false,
  message: {
    text: "",
    variant: "",
  },
  user: {
    username: "",
    userId: "",
    roleId: "",
    avatar: "",
  },
  employeeDetails: {
    employeeId: 0,
    employeeName: "",
    employeeNumber: 0,
    employeeNameNumber: "",
    firstName: "",
    lastName: "",
  },
  rules: [],
  loading: false,
  aliasLoading: false,
  aliased: false,
  isAdUser: false,
  position: {},
  adLogin: adToken => {},
  aliasLogin: username => {},
  aliasLogout: () => {},
  initiateLogin: (e, email, password) => {},
  logout: () => {},
  resetMessageHandler: () => {},
  resetSubmitHandler: (e, username) => {},
  updateUserAvatar: avatar => {},
  adLogout: (removeCookie?, setState?) => {},
  isForbidden: false,
})

export const AuthProvider = authContext.Provider
export const AuthConsumer = authContext.Consumer
